import request from '@/utils/request'
import URL from './urlTranslator'

// 获取Ocr配置全部数据
export function getOcrList(data) {
  return request({
    url: URL.sys.getOcrConfigListUrl,
    method: 'post',
    data
  })
}

// 保存ocr配置
export function saveOcrConfigFunc(data) {
  return request({
    url: URL.sys.saveOcrConfigUrl,
    method: 'post',
    data
  })
}

// 删除配置
export function deleteOcrConfigFunc(data) {
  return request({
    url: URL.sys.deleteOcrConfigUrl,
    method: 'post',
    data
  })
}

// 获取当前租户ocr配置
export function getCurrentOcr() {
  return request({
    url: URL.sys.getCurrentOcr,
    method: 'get'
  })
}
